import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconInspect — 智能质检：盾牌 + 对勾（质量把关通过） */
export default function IconInspect(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M8 2l4.67 1.67v3.33c0 2.93-1.93 4.93-4.67 6-2.73-1.07-4.67-3.07-4.67-6V3.67z" />
      <path d="M6 7.67l1.33 1.33 2.67-2.67" />
    </BizIconSvg>
  );
}
